/**
 * 全局错误处理插件
 * 拦截未捕获的 Vue 错误和 Promise 异常
 */

import type { App } from 'vue'
import { ElMessage } from 'element-plus'

export function setupErrorHandler(app: App) {
  app.config.errorHandler = (err, instance, info) => {
    console.error('[Vue Error]', err, info, instance)
    ElMessage.error('页面发生错误，请刷新后重试')
  }

  window.addEventListener('unhandledrejection', (event) => {
    console.error('[Unhandled Promise Rejection]', event.reason)
    // 不弹全局消息，避免与 Axios 拦截器重复提示
  })
}
